import type { ReactNode } from "react";
import { useAuth } from "../auth/AuthProvider";
import { BrandHeader } from "./BrandHeader";

interface AuthPageShellProps {
  children: ReactNode;
}

export function AuthPageShell({ children }: AuthPageShellProps) {
  const { signOut } = useAuth();

  return (
    <div className="min-h-[100dvh] flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-md p-8">
        <BrandHeader />
        {children}
        <div className="mt-6 text-center">
          <button
            onClick={() => signOut()}
            className="text-sm text-gray-400 underline hover:text-gray-600 transition-colors cursor-pointer"
          >
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
